export const FormTypes = {
  NONE: 'None',
  CREATE: 'Create',
  EDIT: 'Edit'
};
